import { createDesignTokens } from '../../../shared/tmpDesignSystem';

export const lightTheme = createDesignTokens('light');
